import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { logger } from '../../../utils/logger';
import { tokenService } from '../auth/token.service';

async function addAuthHeader(
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> {
  try {
    const token = await tokenService.getToken();
    if (!token) {
      throw new Error('No authentication token available');
    }

    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  } catch (error) {
    logger.error('Failed to add auth header:', error);
    return Promise.reject(error);
  }
}

export const setupAuthInterceptor = (axiosInstance: AxiosInstance): void => {
  axiosInstance.interceptors.request.use(addAuthHeader, error => {
    logger.error('Request interceptor error:', error);
    return Promise.reject(error);
  });

  axiosInstance.interceptors.response.use(
    response => response,
    async error => {
      if (error.response?.status === 401) {
        try {
          const newToken = await tokenService.refreshToken();
          if (newToken && error.config) {
            error.config.headers.Authorization = `Bearer ${newToken}`;
            return axiosInstance.request(error.config);
          }
        } catch (refreshError) {
          logger.error('Token refresh failed:', refreshError);
        }
      }
      return Promise.reject(error);
    }
  );
};
